import { render, staticRenderFns } from "./ProjectContributors.vue?vue&type=template&id=7f69963c&"
import script from "./ProjectContributors.vue?vue&type=script&lang=js&"
export * from "./ProjectContributors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports